<template>

	<div class="sort">
		<a href="javascript:;" :class="{ 'active': currentSort === item.sort }" v-for="(item, index) in sortList" @click="doSort( item.sort )">{{ item.name }}</a>
	</div>

</template>

<script>
export default {
	name: "courseSorter",
	data() {

		let currentSort = this.webUtils.getParameter("sort");
		if ( this.stringUtils.isEmpty(currentSort) ) {
			currentSort = "createDate,DESC";
		}

		const sortList = [];
		sortList.push({
			sort: "createDate,DESC",
			name: "최신순"
		});
		sortList.push({
			sort: "title,ASC",
			name: "강좌순"
		});

		return {
			currentSort,
			sortList,
		}
	},
	created() {

	},
	mounted() {

	},
	methods: {

		doSort ( _sort ) {
			this.currentSort = _sort;
			this.$emit("doSort", _sort);
		}

	}
}
</script>

<style scoped>

</style>